import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'
import { ThemeState } from '../../theme/data/themeSlice'

export const ArticlePlayingContainer = styled.div<ThemeState>`
    ${cssMediaQueryBreakpoints.medium} {
        padding: 12px;
        padding-bottom: 0px;
    }

    ${cssMediaQueryBreakpoints.small} {
        padding: 12px 8px;
        padding-bottom: 0px;
        margin: 0;
        border-radius: 0;
    }

    padding: 12px 16px;
    padding-bottom: 0px;
    background: ${p => p.nowPlayingBgColor};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    z-index: 100;
    margin: 0px;
`
